import { AlertCircle, ArrowRight, CheckCircle2 } from "lucide-react";

import { Label } from "@/shared/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import type { ImportField } from "@/shared/import/import-groups";

export const UNMAPPED = "__unmapped__";

interface Props {
  field: ImportField;
  /// The file column currently mapped to this field, or null.
  picked: string | null;
  fileHeaders: readonly string[];
  onPick: (field: string, fileColumn: string) => void;
}

/// One Pulsewise field paired with a dropdown of the file's columns.
export function ColumnMappingRow({ field, picked, fileHeaders, onPick }: Props) {
  const isOk = picked !== null;
  return (
    <li className="flex items-center gap-2">
      <div className="flex flex-1 items-center justify-between rounded-md border border-border bg-surface-subtle px-3 py-2 text-sm">
        <span>{field.displayName}</span>
        {field.required ? (
          <span className="text-2xs font-medium text-destructive">required</span>
        ) : null}
      </div>
      <ArrowRight className="size-3.5 text-text-tertiary" aria-hidden="true" />
      <div className="flex-1">
        <Label htmlFor={`map-${field.name}`} className="sr-only">
          Map {field.displayName}
        </Label>
        <Select value={picked ?? UNMAPPED} onValueChange={(v) => onPick(field.name, v)}>
          <SelectTrigger id={`map-${field.name}`} className="w-full">
            <SelectValue placeholder="- Not mapped -" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={UNMAPPED}>- Not mapped -</SelectItem>
            {fileHeaders.map((header) => (
              <SelectItem key={header} value={header}>
                {header}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {isOk ? (
        <CheckCircle2 className="size-5 text-success-fg" aria-label="Mapped" />
      ) : field.required ? (
        <AlertCircle className="size-5 text-destructive" aria-label="Required, not mapped" />
      ) : (
        <span className="size-5" aria-hidden="true" />
      )}
    </li>
  );
}
